import uuidv4 from 'uuid/v4';

import money from '../../../helpers/money';
import { isValidRut } from '../../../helpers/transaction-utils';

const extraTimeToExpire = (2 + 0.5) * 3600;

const requiredInternalColumns = [
  'lana_id',
  'name',
  'description',
  'amount',
  'currency',
];
const requiredOutboundColumns = [
  'ident',
  'check_digit',
  'payment_method',
  'account',
  'bank',
  'name',
  'email',
  'amount',
  'currency',
];
const currencyCodeLookup = {
  mexico: 'MXN',
  chile: 'CLP',
};
const validCurrencies = [
  currencyCodeLookup.mexico,
  currencyCodeLookup.chile,
];
const csvOptions = {
  internal: {},
  outbound: {
    noheader: true,
    headers: [
      'start',
      'ident',
      'check_digit',
      'name',
      'document_type',
      'document_number',
      'date',
      'amount',
      'description',
      'payment_method',
      'bank',
      'account',
      'notice_type',
      'email',
      'end',
    ],
  },
  debits: {},
};
const buildId = () => {
  const now = new Date();
  const month = `0${now.getMonth() + 1}`.slice(-2);
  return `${now.getFullYear()}-${month}-${uuidv4()}`;
};
const validateInternalTransfers = (row, t) => {
  const validatedRow = { ...row };
  validatedRow.valid = true;
  const missing = requiredInternalColumns.filter((column) => !Object.keys(validatedRow).includes(column));
  if (missing.length) {
    validatedRow.validation = `${t('batch.missing_fields')}: ${missing.join(', ')}`;
    validatedRow.valid = false;
    return validatedRow;
  }
  const valid = requiredInternalColumns.every((column) => {
    switch (true) {
      case (!validatedRow[column]):
        validatedRow.validation = `${t('batch.invalid_value')}: ${column}`;
        validatedRow.valid = false;
        return false;
      case ((typeof validatedRow[column] === 'string') && !validatedRow[column].trim()):
        validatedRow.validation = `${t('batch.invalid_value')}: ${column}`;
        validatedRow.valid = false;
        return false;
      default:
        return true;
    }
  });
  if (!valid) { return validatedRow; }
  if (!parseFloat(validatedRow.amount)) {
    validatedRow.validation = t('batch.invalid_amount');
    validatedRow.valid = false;
    return validatedRow;
  }
  if (!validCurrencies.includes(validatedRow.currency)) {
    validatedRow.validation = t('batch.invalid_currency');
    validatedRow.valid = false;
    return validatedRow;
  }
  validatedRow.id = buildId();
  validatedRow.now = Math.floor(Date.now() / 1000);
  validatedRow.amount = money.toInt(validatedRow.amount, validatedRow.currency, false);
  return validatedRow;
};
const buildGatewayUri = ({ account, name, ident, check_digit, bank, payment_method, email, description }) => (
  `cl-lpg:${account}?name=${name}&ident=${ident}${check_digit}&bank=${bank}&payment_method=${payment_method}&email=${email}&description=${description}`
);
const buildMxSpeiUri = ({ name, clabe, rfcOrCurp }) => (
  `mx-spei:${clabe}?name=${name}${(rfcOrCurp) ? `&rfc_or_curp=${rfcOrCurp}` : ''}`
);
const validateOutboundTransfers = (row, t) => {
  const validatedRow = { ...row };
  validatedRow.currency = currencyCodeLookup.chile;
  validatedRow.valid = true;
  const valid = requiredOutboundColumns.every((column) => {
    if ((!validatedRow[column]) || ((typeof validatedRow[column] === 'string') && validatedRow[column].trim() === '')) {
      validatedRow.validation = `${t('batch.invalid_value')}: ${column}`;
      validatedRow.valid = false;
      return false;
    }
    return true;
  });
  if (!valid) { return validatedRow; }
  if (!parseFloat(validatedRow.amount)) {
    validatedRow.validation = t('batch.invalid_amount');
    validatedRow.valid = false;
    return validatedRow;
  }
  if (!isValidRut(`${validatedRow.ident}${validatedRow.check_digit}`)) {
    validatedRow.validation = t('batch.invalid_rut');
    validatedRow.valid = false;
    return validatedRow;
  }
  const missing = requiredOutboundColumns.filter((x) => !Object.keys(validatedRow).includes(x));
  if (missing.length) {
    validatedRow.validation = `${t('batch.missing_fields')}: ${missing.join(', ')}`;
    validatedRow.valid = false;
    return validatedRow;
  }
  if (validatedRow.valid) {
    validatedRow.amount = money.toInt(validatedRow.amount, validatedRow.currency, false);
  }
  validatedRow.id = buildId();
  validatedRow.now = Math.floor(Date.now() / 1000 + extraTimeToExpire);
  validatedRow.destination = {
    gateway_uri: buildGatewayUri(validatedRow),
  };
  return validatedRow;
};
const validate = {
  internal: validateInternalTransfers,
  outbound: validateOutboundTransfers,
};
export { validate, csvOptions, buildMxSpeiUri };
